import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
  ErrorHandler,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideHighcharts } from 'highcharts-angular';
import * as Highcharts from 'highcharts';
// Import Highcharts modules as side effects to initialize them
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/offline-exporting';

import { routes } from '@app/app.routes';
import { AuthService } from '@core/services/auth.service';
import { AuthConfigModule } from '@core/auth/auth-config.module';
import { AppErrorHandler } from '@core/error-handler';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { retryInterceptor } from '@core/interceptors/retry.interceptor';
import { activityTrackingInterceptor } from '@core/interceptors/activity-tracking.interceptor';
import { errorMappingInterceptor } from '@core/interceptors/error-mapping.interceptor';
import { errorNotificationInterceptor } from '@core/interceptors/error-notification.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(
      // Order matters: retry is innermost so retries finish before errorNotification
      // sees the (still raw) error; errorMapping converts it afterwards for callers.
      withInterceptors([
        authInterceptor,
        activityTrackingInterceptor,
        errorMappingInterceptor,
        errorNotificationInterceptor,
        retryInterceptor,
      ]),
    ),
    provideHighcharts({
      instance: () => Promise.resolve(Highcharts),
    }),
    importProvidersFrom(AuthConfigModule),
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler,
    },
    AuthService,
  ],
};
